<!--Tabs:下载中心tab切换 2021/09/29 13:35:56 Sunanguang-->

<template>
  <div class="its-tabs" :style="tabStyle">
    <div class="its-tab" :style="{width: 100 / tabs.length + '%'}" v-for="(tab, i) in tabs" :key="'tab-' + i" :class="[tab.id === selectedTab.id ? 'active' : '']" @click="changeTab(tab)">{{tab.mainTitle}}</div>
  </div>
</template>
<script>
export default {
  name: 'Tabs',
  props: {
    tabs: {
      type: Array,
      default: function () {
        return []
      }
    },
    selectedTab: {
      type: Object,
      default: function () {
        return { id: 1 }
      }
    },
    offset: {
      type: Number,
      default: 74
    }
  },
  computed: {
    tabStyle: function () {
      const index = this.selectedTab.id - 1
      console.log(index);
      const width = 100 / this.tabs.length
      const style = {
        'background-size': width + '% 100%',
        'background-position': 'calc((' + width + '% + ' + this.offset + 'px) * ' + index + ') 0'
      }
      if (index === 0) {
        style['background-position'] = '-1px 0'
        style['background-image'] = 'url(' + require('../../../../assets/images/download/tab_bg1.png') + ')'
      } else if (index === this.tabs.length - 1) {
        style['background-image'] = 'url(' + require('../../../../assets/images/download/tab_bg3.png') + ')'
        style['background-position'] = 'calc(100% + 1px) 0'
      }
      return style
    }
  },
  methods: {
    changeTab: function (tab) {
      this.$emit('change-tab', tab)
    }
  }
}
</script>

<style scoped>
.its-tabs {
  width: 1200px;
  height: 78px;
  line-height: 78px;
  border: 1px solid white;
  border-radius: 8px;
  margin: 137px auto 0 auto;
  position: absolute;
  left: 0;
  right: 0;
  background-image: url(../../../../assets/images/download/tab_bg2.png);
  background-repeat: no-repeat;
}

.its-tabs .its-tab {
  float: left;
  width: 25%;
  color: white;
  font-size: 20px;
  text-align: center;
  cursor: pointer;
}

.its-tabs .its-tab.active {
  color: #4873f3;
}
</style>